import { ReactNode } from 'react';
import { OnHoverTooltip } from './OnHoverTooltip';

interface TextEllipsisProps {
    children: ReactNode;
    overlay?: ReactNode;
}

export function TextEllipsis({ children, overlay }: TextEllipsisProps) {
    return (
        <OnHoverTooltip overlay={overlay ?? children}>
            <span className="text-ellipsis">{children}</span>
        </OnHoverTooltip>
    );
}
